const Menu = skin => {
  const boxShadow = theme => {
    if (skin === 'bordered') {
      return theme.shadows[0]
    } else if (theme.palette.mode === 'light') {
      return theme.shadows[8]
    } else {
      return theme.shadows[9]
    }
  }

  return {
    MuiMenu: {
      defaultProps: {
        disableScrollLock: true
      },
      styleOverrides: {
        root: ({ theme }) => ({
          '& .MuiMenu-paper': {
            borderRadius: 5,
            boxShadow: boxShadow(theme),
            backgroundColor: theme.palette.mode === 'light' ? '#FFFFFF' : theme.palette.background.paper,
            ...(skin === 'bordered' && { border: `1px solid ${theme.palette.divider}` })
          }
        })
      }
    }
  }
}

export default Menu
